import Report from '../../models/Report'

export const ReportModule = {
  namespaced: true,

  state: {
    report: new Report({})
  },

  getters: {
    report (state) {
      return state.report
    }
  },

  mutations: {
    setReport (state, report) {
      state.report = new Report(report)
    }
  }
}

export default ReportModule